import { Link } from "react-router-dom";
import styled from "styled-components";

export const SearchWrapper = styled.div`
  width: calc(var(--u) * 400);
  position: relative;
`;

export const Bar = styled.div`
  width: calc(var(--u) * 250);
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.background};
  display: flex;
  align-items: center;
  border-radius: 16px;
  gap: var(--sp-4);
  text-shadow: -0.5px -0.5px 0 #000, 0.5px -0.5px 0 #000, -0.5px 0.5px 0 #000,
    1px 1px 0 #000;
  border: 0.5px solid #000;
  padding: var(--sp-4) var(--sp-6);

  &:focus-within {
    width: 100%;
  }
`;

export const Label = styled.label`
  width: 100%;
  position: relative;
`;

export const Input = styled.input`
  border: none;
  padding: calc(var(--u) * 7) 0;
  padding-left: var(--sp-32);
  width: calc(var(--u) * 265);
  border-radius: 0;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  width: 100%;

  &::placeholder {
    color: ${({ theme }) =>
      theme.colors.text}; // Adicione uma cor específica para o placeholder
  }

  &:focus {
    outline: none;
  }
`;

export const Icon = styled.div`
  font-family: "Material Icons";
  font-size: var(--fs-3xl);
  font-style: normal;
  font-weight: normal;
  position: absolute;
  padding: var(--sp-5) 0;
  color: ${({ theme }) => theme.colors.selection};
  cursor: pointer;
`;

export const CommandPalletButton = styled.button`
  all: unset;

  &:focus {
    outline: 2px solid;
    outline-offset: 2px;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  width: calc(var(--u) * 50);
  img {
    width: 100%;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  margin-top: calc(var(--u) * 1);
  background-color: rgba(225, 225, 225, 0.9);
  width: 100%;
  border-radius: 16px;
  overflow: hidden;

  a {
    text-decoration: none;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const NavWrapper = styled.div`
  overflow-y: auto;
  margin: var(--sp-10);
  max-height: calc(var(--u) * 360);
  display: flex;
  flex-direction: column;
  gap: var(--sp-20);
  width: 100%;

  a {
    display: block;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.background};
    font-size: 110%;
    font-weight: bold;
    text-shadow: -0.5px -0.5px 0 #000, 0.5px -0.5px 0 #000, -0.5px 0.5px 0 #000,
      1px 1px 0 #000;
    padding: var(--sp-10) 0;
    &:hover {
      color: ${({ theme }) => theme.colors.selection};
      width: 100%;
    }
  }
`;

export const MainGroup = styled.div`
  p {
    font-weight: bold;
    font-size: var(--fs-xl);
  }
`;

export const SubGroup = styled.ul`
  padding: var(--sp-8) var(--sp-12);
  display: flex;
  flex-direction: column;
  gap: var(--sp-12);
`;

export const SubGroupList = styled.li<{ level: number }>`
  list-style: none;
  border-bottom: ${({ level }) => (level > 1 ? "2px" : "1px")} solid
    ${({ theme }) => theme.colors.text};
  padding: var(--sp-8) 0;
`;

export const SubGroupTitle = styled(Link)`
  font-weight: lighter;
  font-size: var(--fs-base);
`;

export const SubGroupItems = styled.ul`
  padding: var(--sp-4) var(--sp-10);
  list-style: none;
`;
